import { Grid } from "@mui/material";
import React from "react";
import { getAssets } from "@unisearch/helpers";
import styles from "./metrics.module.scss";

export const UniPageAnalyticsMetrics = () => {
  return (
    <section className={styles.section_metrics}>
      <div className="container">
        <Grid container spacing={4} alignItems="center">
          <Grid item sm={12} md={6}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_metrics.png")}
                alt="Data metrics"
              />
            </div>
          </Grid>

          <Grid item sm={12} md={6}>
            <h2 className={styles.title}>Up-to-Date Metrics</h2>
            <p className={`${styles.sub_title} font-medium`}>
              Your UniSearch dashboard features real-time metrics of student
              behaviour - from engagement patterns across your programs,
              profile, and posts to conversion and application completion rates.
            </p>
            <p className={`font-medium`}>
              Knowing these metrics in real-time helps you course-correct on the
              spot to tailor your recruitment processes and strategies as
              necessary to your goals. This helps you save a ton of time, money,
              effort, and more while keeping your student recruitment pipeline
              running smoothly and efficiently.
            </p>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageAnalyticsMetrics;
